<template>
    <div class="container">
        example tailwind

        <div class="fixed w-full bottom-0 bg-gray-200">
            <div class="flex p-3">
                <div class="flex">
                    <div class="bg-gray-500 border-4 border-gray-500 w-8 text-center py-2">
                        -
                    </div>
                    <div class="w-8 text-center border-4 border-opacity-0 py-2">
                        5
                    </div>
                    <div class="bg-white border-4 border-red-600 w-8 text-center py-2">
                        +
                    </div>
                </div>
                <div class="flex-grow pl-4">
                    <button class="bg-red-600 text-white w-full p-3">Add to cart</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FooterBottom',
}
</script>
<style lang="scss" scoped>

</style>
